import loglevel from 'loglevel';
import { appEnv, secureCdnHost } from 'config';
import { AppEnvs } from 'enums';
import { newRelicEmitter, UNFULFILLED_PROMISE_EVENT} from 'lib/metrics/newRelicEventBus';
import request from './cache/requestCache';
import proxy from './requestProxy';
import fallback from './cache/fallbackCache';
import staticConfigQa from 'config/watchespn-web-1.0.config.qa.json';
import staticConfig from 'config/watchespn-web-1.0.config.json';

const log = loglevel.getLogger('Bootstrap');

const DEFAULT_EXPIRATION = 300;
const DEFAULT_TIMEOUT = 5000;
const BOOTSTRAP_URL = {
    [AppEnvs.dev]: `${secureCdnHost}/connected-devices/app-configurations/watchespn-web-3.0_dev.config.json`,
    [AppEnvs.qa]: `${secureCdnHost}/connected-devices/app-configurations/watchespn-web-3.0_qa.config.json`,
    [AppEnvs.prod]: `${secureCdnHost}/connected-devices/app-configurations/watchespn-web-3.0.config.json`
};

export function getUrl(env = appEnv) {
    let url = BOOTSTRAP_URL[env];
    if (!process.browser) { // use non ssl domain for server side
        url = url.replace(secureCdnHost, 'http://proxy.espn.com');
    }
    return url;
}

export function getFallbackConfig(env = appEnv) {
    return env === AppEnvs.prod ? staticConfig : staticConfigQa;
}

export function loadBootstrap({ configEnv } = {}) {
    const url = getUrl(configEnv);
    return request.get(url)
        .expiration(DEFAULT_EXPIRATION)
        .use(proxy)
        .timeout(DEFAULT_TIMEOUT)
        .then(({ body }) => {
            fallback.set(url, body);
            return body;
        })
        .catch((err) => {
            log.error(`loadBootstrap: ${url}`, err.status, err.originalError);
            newRelicEmitter.emit(UNFULFILLED_PROMISE_EVENT, err);
            return fallback.get(url)
                .then(config => {
                    if (!config) {
                        log.error('loadBootstrap: using fallbackConfig');
                        const fallbackConfig = getFallbackConfig(configEnv);
                        return fallbackConfig;
                    }
                    return config;
                });
        });
}



// WEBPACK FOOTER //
// ./app/lib/api/Bootstrap.js